import { isAdditionalInfoFormEnabled } from 'utils/env'

export const getRequestAdditionalInformationButtonLabel = (): string =>
  isAdditionalInfoFormEnabled() ? 'Request Additional Information' : 'Request Attestation'

export const getRequireAdditionalInfoModalTitle = (): string =>
  isAdditionalInfoFormEnabled()
    ? 'Require additional information for this request?'
    : 'Require attestation for this request?'

export const getRequireAdditionalInfoModalSubmitLabel = (): string =>
  isAdditionalInfoFormEnabled() ? 'Require additional information' : 'Require attestation'

export const getRequireAdditionalInfoModalBody = (): string =>
  isAdditionalInfoFormEnabled()
    ? 'By requiring additional information, this request will be rejected and the requester will be notified to complete the additional information request form.'
    : 'By requiring attestation, this request will be rejected and the requester will be notified to complete the attestation form.'

export const getRequestAdditionalInfoErrorMessage = (): string =>
  isAdditionalInfoFormEnabled()
    ? 'There was an error while requesting additional information. Please try again or contact the administrator.'
    : 'There was an error while requesting attestation. Please try again or contact the administrator.'

export const getAdditionalInfoRequestedSuccessToast = (): string =>
  isAdditionalInfoFormEnabled() ? 'Additional information requested successfully' : 'Attestation requested successfully'

export const getRequestAdditionalInfoFailedToast = (): string =>
  isAdditionalInfoFormEnabled() ? 'Failed to request additional information' : 'Failed to request attestation'

export const getAdditionalInfoRequestContextPrefix = (): string =>
  isAdditionalInfoFormEnabled() ? 'This is an additional information request. ' : 'This is an attestation request. '

export const getAttestationFormTypeLabel = (): string =>
  isAdditionalInfoFormEnabled() ? 'Additional Information Request Form' : 'Attestation Form'
